import { render, staticRenderFns } from "./AddClientAddressModal.vue?vue&type=template&id=8bff5d14&scoped=true"
import script from "./AddClientAddressModal.vue?vue&type=script&lang=js"
export * from "./AddClientAddressModal.vue?vue&type=script&lang=js"
import style0 from "./AddClientAddressModal.vue?vue&type=style&index=0&id=8bff5d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bff5d14",
  null
  
)

export default component.exports